var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container my-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 search-tips-col",domProps:{"innerHTML":_vm._s(_vm.getSetting(_vm.type))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }